<template>
     <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pb-2 mt-1" >
                <v-col sm="6" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('advanced_fulfillment_returned.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="right white_highlight--text mr-2" style="max-width: 40px !important; min-width: 40px !important" color="secondary" @click="modalOrdersIdentifier = true">
                                <v-icon class="material-icons-outlined" small>content_paste_search</v-icon>
                            </v-btn>
                        </template>

                        <span>{{$t('advanced_fulfillment_returned.orders_identifier')}}</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="right white_highlight--text mr-2" style="max-width: 40px !important; min-width: 40px !important" color="secondary" @click="modalProductsSummary = true">
                                <v-icon class="material-icons-outlined" small>content_paste</v-icon>
                            </v-btn>
                        </template>

                        <span>{{$t('advanced_fulfillment_returned.products_summary')}}</span>
                    </v-tooltip>
                    <v-btn class="right white_highlight--text tools-view-height" color="secondary" @click="modalUploadIncidences = true">
                        {{ $t('advanced_fulfillment_returned.upload_returns') }}
                        <v-icon class="material-icons-outlined px-1" small>cloud_upload</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <v-data-table class="px-0 my-2"
                                no-results-text="No hay resultados"
                                :headers="headers"
                                :items="props.items"
                                :search="props.search"
                                calculate-widths
                                :footer-props="{
                                    'items-per-page-text': this.$t('datatable.shown'),
                                    showFirstLastPage: true,
                                    firstIcon: 'mdi-arrow-collapse-left',
                                    lastIcon: 'mdi-arrow-collapse-right',
                                    pageText: '{0}-{1} ' + this.$t('datatable.of') + ' {2} ' + this.$t('datatable.results'),
                                    'show-current-page': true,
                                    'items-per-page-options': typeof props.rowsPP === 'undefined' ? [10, 25, 50, 100] : props.rowsPP}"
                                :page="1"
                                :mobile-breakpoint="0"
                                item-key="uon"
                            >
                                <template v-slot:item.actions="{ item }">
                                    <v-tooltip top v-for="(action, i) of item.actions" :key="i">
                                        <template v-slot:activator="{ on }">
                                            <v-btn x-small v-if="!('link' in action)" icon @click="methodHandler(action.method, item.parameters)" :disabled="action.method === null">
                                                <v-icon class="material-icons-outlined" :color="action.icon.color" v-on="on">{{ action.icon.icon }}</v-icon>
                                            </v-btn>
                                            <v-btn x-small v-else icon text :to="action.link" :disabled="action.link === null">
                                                <v-icon class="material-icons-outlined" :color="action.icon.color" v-on="on">{{ action.icon.icon }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ action.name }}</span>
                                    </v-tooltip>
                                </template>
                                <v-data-footer :items-per-page-options="[]"></v-data-footer>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
            <v-dialog v-model="modalDelete" persistent max-width="90%">
                <v-card >
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h3 class="text-uppercase">
                                {{ $t('advanced_fulfillment_returned.modal.delete') }}
                            </h3>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="py-3 my-3 text-center">
                            <v-col cols="12">
                                <h5>{{ $t('advanced_fulfillment_returned.modal.message') }}</h5>
                            </v-col>
                        </v-row>
                        
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalDelete = false">{{ $t('advanced_fulfillment_returned.no') }}</v-btn>
                            <v-btn color="error" @click="restoreOrder">
                                {{ $t('advanced_fulfillment_returned.yes') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalDetail" persistent max-width="90%" v-if="orderToShow != null">
                <v-card style="min-width: 700px !important">
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h4 class="text-uppercase blue_accent--text py-2">
                                {{ $t('advanced_fulfillment_sent.order_details.header') }} {{ this.orderToShow.uniqueOrderNumber }}
                            </h4>
                        </v-row>
                    </v-card-title>

                    <div class="marker1-1" style="font-weight:bold"><label class="mx-1">{{ $t('advanced_fulfillment_sent.details') }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("advanced_fulfillment_sent.order_number") }}</label> <label>{{ this.orderToShow.uniqueOrderNumber }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("advanced_fulfillment_sent.date") }}</label> <label>{{ this.orderToShow.createdAt }}</label></div>
                    <div class="detail_content1" v-if="shipping_service != 'otra'"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.shipping_service") }}</label> <label>{{ this.orderToShow.shippingService }}</label></div>
                    <div class="detail_content1" v-if="shipping_service == 'otra'"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.shipping_service") }}</label> <label>{{ this.orderToShow.externalShippingService }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.invoice") }}</label> <label>{{ this.orderToShow.invoice }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.client != null"><label style="font-weight:bold">{{ $t("advanced_fulfillment_sent.client") }}</label> <label>{{ this.orderToShow.client.name }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("advanced_fulfillment_sent.cod") }}</label> <label>{{ this.orderToShow.total }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("advanced_fulfillment_sent.buyer") }}</label> <label>{{ this.orderToShow.consignee.name }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("advanced_fulfillment_sent.state") }}</label> <label>{{ this.orderToShow.consignee.state }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("advanced_fulfillment_sent.municipality") }}</label> <label>{{ this.orderToShow.consignee.municipality }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("advanced_fulfillment_sent.neighborhood") }}</label> <label>{{ this.orderToShow.consignee.neighborhood }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.address") }}</label> <label>{{ this.orderToShow.consignee.street }} {{ this.orderToShow.consignee.externalNumber }} {{ this.orderToShow.consignee.internalNumber }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("advanced_fulfillment_sent.zip_code") }}</label> <label>{{ this.orderToShow.consignee.zipcode }}</label></div>
                    
                    <div class="marker1-1 mt-2" style="font-weight:bold"><label class="mx-1">{{ $t('advanced_fulfillment_sent.products') }}</label></div>
                    <span v-if="orderToShow.shipmentProductDetail != null">
                        <div v-for="(product, i) of orderToShow.shipmentProductDetail.data" :key="i" class="detail_content1"><label style="font-weight:bold">{{ product.attributes.product.sku }}</label> <label>{{ product.attributes.quantity }}</label></div>
                    </span>
                    
                    <div class="marker1-1 mt-2" style="font-weight:bold"><label class="mx-1">{{ $t('advanced_fulfillment_sent.tracking_history') }}</label></div>
                    <div v-for="status of orderToShow.orderStatus" :key="status.id" class="detail_content1"><label style="font-weight:bold">{{ status.attributes.status }}</label> <label>{{ status.attributes.createdAt }}</label></div>

                    <v-card-text class="mt-5">
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn  color="secondary" class="white_highlight--text" @click="modalDetail = false">
                                {{ $t('advanced_fulfillment_sent.go_back') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalUploadIncidences" persistent max-width="90%" >
                <v-card style="min-width: 500px">
                <v-card-title class="justify-center">
                    {{ $t('advanced_fulfillment_returned.upload_returns') }}
                </v-card-title>
                    <v-stepper v-model="stepper2">
                        <v-stepper-items>
                            <v-stepper-content step="1" class="mx-0 px-0">
                                <v-card flat class="mb-5">
                                    <v-form ref="form2" lazy-validation>
                                        <v-row class="mx-0 px-0" justify="center" align="center">
                                            <v-col cols="10">
                                                <v-file-input v-model="inputFile2" accept=".csv" :label="$t('advanced_fulfillment_returned.returns_file')" append-outer-icon="attach_file" prepend-icon="null" :rules="rules_required"></v-file-input>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn class="mx-0" small color="secondary" v-bind="attrs" v-on="on" @click="stepper2 = 4">
                                                            <v-icon class="material-icons-outlined" aria-hidden="false" color="white" small>
                                                                help
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{ $t('advanced_fulfillment_returned.help') }}</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-card>
                                <v-row class="mx-2 px-5 mx-5 py-0" justify="end" align="end">
                                    <v-col cols="2" justify="end" align="end" class="mr-8">
                                        <v-btn text  @click="modalUploadIncidences = false;" >
                                            {{ $t('advanced_fulfillment_returned.cancel') }}
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="2" justify="end" align="end">
                                        <v-btn class="white_highlight--text" color="secondary" @click="uploadReturns" >
                                            {{ $t('advanced_fulfillment_returned.load') }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-stepper-content>

                            <v-stepper-content step="2">
                                <v-card flat class="mb-5">
                                    <v-card-text class="my-0 py-0">
                                        <p class="my-0 py-0">{{readRows2.length}} {{ $t('advanced_fulfillment_returned.orders_in_file') }}</p>
                                    </v-card-text>
                                    <v-simple-table v-if="this.readRows2.length > 0" fixed-header height="300px">
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th style="background-color:#c1d500; font-weight:bold !important; color:black !important" v-for="(th, key) in sTHeaders2" :key="key" class="text-left">{{ $t('advanced_fulfillment_returned.' + th) }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, i) in readRows2" :key="i">
                                                    <td v-for="(td, j) in item.split(',')" :key="j">{{ td }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card>

                                <div class="d-flex">
                                    <v-spacer></v-spacer>
                                    <v-btn class="px-3" text @click="stepper2 = 1; sTHeaders2 = []; readRows2 = []">{{ $t('advanced_fulfillment_returned.cancel') }}</v-btn>
                                    <v-btn color="secondary" class="white_highlight--text px-3" @click="saveFile">
                                        {{ $t('advanced_fulfillment_returned.save_data') }}
                                    </v-btn>
                                </div>
                            </v-stepper-content>

                            <v-stepper-content step="4">
                                    <p class="py-0 my-0">1.- Conserve todos los encabezados en el orden presentado y sin modificarlos.</p> 
                                    <p class="py-0 my-0">2.- Llene la información de acuerdo al campo solicitado, no utilice comas en ninguno de los campos, evite el uso de signos de interrogación, comillas o signos de admiración.</p> 
                                    <p class="py-0 my-0">3.- A continuación se muestra una línea de ejemplo para familiarizarse con el formato.</p> 
                                    <p class="py-0 my-0">4.- El archivo de productos debe ser formato CSV.</p> 
                                    <p class="py-0 my-0">5.- El formato de la fecha debe ser AAAA-MM-DD.</p> 
                                    <p class="py-0 my-0">Columnas: </p>
                                    <v-simple-table fixed-header>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                   <th class="text-left" style="padding: 0 5px !important;">Orden</th>
                                                   <th class="text-left" style="padding: 0 5px !important;">Fecha</th>
                                                   <th class="text-left" style="padding: 0 5px !important;">Rack</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>O-00001</td>
                                                    <td>2024-01-01</td>
                                                    <td>10001</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <v-row align="center" justify="center" class="my-3">
                                        <v-btn color="secondary" class="white_highlight--text" @click="stepper2 = 1">
                                            {{ $t('products.go_back') }}
                                        </v-btn>
                                    </v-row>
                                </v-stepper-content>
                            
                            <v-stepper-content step="3">
                                <v-card flat class="mb-5">
                                    <v-simple-table v-if="this.responses.length > 0" fixed-header height="300px">
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th style="background-color:#c1d500; font-weight:bold !important; color:black !important" class="text-left">{{ $t('advanced_fulfillment_returned.order') }}</th>
                                                    <th style="background-color:#c1d500; font-weight:bold !important; color:black !important" class="text-left">{{ $t('advanced_fulfillment_returned.status') }}</th>
                                                    <th style="background-color:#c1d500; font-weight:bold !important; color:black !important" class="text-left">{{ $t('advanced_fulfillment_returned.message') }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, i) in responses" :key="i">
                                                    <td>{{ item.order }}</td>
                                                    <td>{{ item.status }}</td>
                                                    <td>{{ item.message }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card>

                                <div class="d-flex">
                                    <v-btn class="px-3" text @click="stepper2 = 1; sTHeaders2 = []; readRows2 = []; modalUploadIncidences = false;">{{ $t('advanced_fulfillment_returned.close') }}</v-btn>
                                </div>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalOrdersIdentifier" persistent max-width="90%" >
                <v-card style="min-width: 500px">
                <v-card-title class="justify-center">
                    {{ $t('advanced_fulfillment_returned.orders_identifier') }}
                </v-card-title>
                    <v-stepper v-model="stepper2">
                        <v-stepper-items>
                            <v-stepper-content step="1" class="mx-0 px-0">
                                <v-card flat class="mb-5">
                                    <v-form ref="form2" lazy-validation>
                                        <v-row class="mx-0 px-0" justify="center" align="center">
                                            <v-col cols="10">
                                                <v-file-input v-model="orders_identifier.file" accept=".csv" :label="$t('advanced_fulfillment_returned.guides_file')" append-outer-icon="attach_file" prepend-icon="null" :rules="rules_required"></v-file-input>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn class="mx-0" small color="secondary" v-bind="attrs" v-on="on" @click="stepper2 = 2">
                                                            <v-icon class="material-icons-outlined" aria-hidden="false" color="white" small>
                                                                help
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{ $t('advanced_fulfillment_returned.help') }}</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-card>
                                <v-row class="pr-8 py-0" justify="center" align="center">
                                    <v-col cols="2" justify="center" align="center" class="mr-10">
                                        <v-btn text  @click="modalOrdersIdentifier = false;" >
                                            {{ $t('advanced_fulfillment_returned.cancel') }}
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="2" justify="center" align="center">
                                        <v-btn class="white_highlight--text" color="secondary" @click="exportIdentifier()" >
                                            {{ $t('advanced_fulfillment_returned.import') }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <!-- <div class="d-flex">
                                    <v-btn class="px-3" text @click="stepper2 = 1; sTHeaders2 = []; readRows2 = []; modalUploadIncidences = false;">{{ $t('advanced_fulfillment_returned.close') }}</v-btn>
                                </div> -->
                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <v-card-text>
                                    <p class="py-0 my-0">1.- Conserve todos los encabezados en el orden presentado y sin modificarlos.</p> 
                                    <p class="py-0 my-0">2.- Llene la información de acuerdo al campo solicitado, no utilice comas en ninguno de los campos, evite el uso de signos de interrogación, comillas o signos de admiración.</p> 
                                    <p class="py-0 my-0">3.- A continuación se muestra una línea de ejemplo para familiarizarse con el formato.</p> 
                                    <p class="py-0 my-0">4.- El archivo de compromisos debe ser formato CSV.</p> 
                                    <p class="py-0 my-0">Columnas: </p>
                                    <v-simple-table fixed-header>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left" style="padding: 0 5px !important;">tracking_guide</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>391793712572</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <v-row align="center" justify="center" class="my-3">
                                        <v-btn color="secondary" class="white_highlight--text" @click="stepper2 = 1">
                                            {{ $t('yego_reports.close') }}
                                        </v-btn>
                                    </v-row>
                                </v-card-text>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalProductsSummary" persistent max-width="90%" >
                <v-card style="min-width: 500px">
                <v-card-title class="justify-center">
                    {{ $t('advanced_fulfillment_returned.products_summary') }}
                </v-card-title>
                    <v-stepper v-model="stepper">
                        <v-stepper-items>
                            <v-stepper-content step="1" class="mx-0 px-0">
                                <v-card flat class="mb-5">
                                    <v-form ref="form2" lazy-validation>
                                        <v-row class="mx-0 px-0" justify="center" align="center">
                                            <v-col cols="10">
                                                <v-file-input v-model="products_by_orders_summary.file" accept=".csv" :label="$t('advanced_fulfillment_returned.guides_file')" append-outer-icon="attach_file" prepend-icon="null" :rules="rules_required"></v-file-input>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn class="mx-0" small color="secondary" v-bind="attrs" v-on="on" @click="stepper = 2">
                                                            <v-icon class="material-icons-outlined" aria-hidden="false" color="white" small>
                                                                help
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{ $t('advanced_fulfillment_returned.help') }}</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-card>
                                <v-row class="mx-2 px-8 mx-5 py-0" justify="end" align="end">
                                    <v-col cols="2" justify="end" align="end" class="mr-10">
                                        <v-btn text  @click="modalProductsSummary = false;" >
                                            {{ $t('advanced_fulfillment_returned.cancel') }}
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="2" justify="end" align="end">
                                        <v-btn class="white_highlight--text" color="secondary" @click="productsByOrdersSummary()" >
                                            {{ $t('advanced_fulfillment_returned.upload') }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <!-- <div class="d-flex">
                                    <v-btn class="px-3" text @click="stepper2 = 1; sTHeaders2 = []; readRows2 = []; modalUploadIncidences = false;">{{ $t('advanced_fulfillment_returned.close') }}</v-btn>
                                </div> -->
                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <p class="py-0 my-0">1.- Conserve todos los encabezados en el orden presentado y sin modificarlos.</p> 
                                <p class="py-0 my-0">2.- Llene la información de acuerdo al campo solicitado, no utilice comas en ninguno de los campos, evite el uso de signos de interrogación, comillas o signos de admiración.</p> 
                                <p class="py-0 my-0">3.- A continuación se muestra una línea de ejemplo para familiarizarse con el formato.</p> 
                                <p class="py-0 my-0">4.- El archivo de compromisos debe ser formato CSV.</p> 
                                <p class="py-0 my-0">Columnas: </p>
                                <v-simple-table fixed-header>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-left" style="padding: 0 5px !important;">shipment_number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>38920190</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <v-row align="center" justify="center" class="my-3">
                                    <v-btn color="secondary" class="white_highlight--text" @click="stepper = 1">
                                        {{ $t('yego_reports.close') }}
                                    </v-btn>
                                </v-row>
                            </v-stepper-content>
                            <v-stepper-content step="3">
                                <v-card-text>
                                    <p class="py-0 my-0">{{ ordersLength }} {{ $t('yego_reports.orders_in_file') }} </p> 
                                    <v-simple-table fixed-header>
                                        <template v-slot:default>

                                            <thead>
                                                <tr>
                                                    <th class="text-left" style="padding: 0 5px !important;">{{ $t('yego_reports.products') }}</th>
                                                    <th class="text-left" style="padding: 0 5px !important;">{{ $t('yego_reports.quantity')}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, i) in productsSummary" :key="i">
                                                    <td>{{ item.sku }}</td>
                                                    <td>{{ item.quantity }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <v-row align="center" justify="center" class="my-3">
                                        <v-btn color="secondary" class="white_highlight--text" @click="modalProductsSummary = false; results = []">
                                            {{ $t('yego_reports.accept') }}
                                        </v-btn>
                                    </v-row>
                                </v-card-text>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-card>
            </v-dialog>
        </v-container>        
    </div>
</template>
<script>

import FileSaver from 'file-saver';

export default {
	computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]},
        headers(){
            return [
                { text: this.$t('advanced_fulfillment_returned.order'), value: 'uniqueOrderNumber' },
                { text: this.$t('advanced_fulfillment_returned.client'), value: 'client.name' },
                { text: this.$t('advanced_fulfillment_returned.shipping_number'), value: 'shipmentNumber' },
                { text: this.$t('advanced_fulfillment_returned.return'), value: 'date' },
                { text: this.$t('advanced_fulfillment_returned.actions'), value: 'actions' },
            ];
        }
    },
    data(){
        return {
            shipping_service: this.$route.params.shipping_service,
            props: {
                search: '',
                items: [],
            },
            modalDelete: false,
            modalDetail: false,
            modalUploadIncidences: false,
            modalUploadreturn: false,
            modalOrdersIdentifier: false,
            modalProductsSummary: false,
            orderToDelete: '',
            orderToShow: '',
            inputFile2: [],
            readFile2: '',
            readRows2: [],
            stepper2: 1,
            stepper: 1,
            sTHeaders2:'',
            responses: [],
            menu: false,
            orders_identifier:{
                file: []
            },
            products_by_orders_summary:{
                file: []
            },
            ordersLength: "",
            productsSummary: "",
            returned: {
                unique_order_number: "",
                warehouse_id: this.$store.state.warehouseId,
                client_id: "",
                date: "",
                products: []
            },
            actions:[
                {
                    name: this.$t('advanced_fulfillment_returned.details'),
                    icon: {
                        color: 'accent',
                        icon: 'info'
                    },
                    method: 'showDetails',
                },
                {
                    name: this.$t('advanced_fulfillment_returned.incidence'),
                    icon: {
                        color: 'accent',
                        icon: 'warning_amber'
                    },
                    link: '/shipments/cod/incidence/10000',
                },
                {
                    name: this.$t('advanced_fulfillment_returned.restore'),
                    icon: {
                        color: 'accent',
                        icon: 'restore'
                    },
                    method: 'askRestore',
                },
            ],
            controller_name: "advanced_fulfillment"
        }
    },
    mounted(){
        this.$store.state.module = "headers.advanced_fulfillment_" + this.shipping_service + "_returned";

        if(this.shipping_service == "eon") this.controller_name = "advanced_external_fulfillment";
        else this.controller_name = "advanced_fulfillment"

        this.index();
    },
    methods: {
        methodHandler(object, params){
            this[object](params)
        },
        index(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.props.items = [];
            this.$http.get(this.$store.state.chronosApi + 'v1/' + this.controller_name + '/returned_orders?page=1&per_page=100&shipping_service=' + this.shipping_service.toUpperCase(), {headers: {Authorization: lsToken}})
            .then((response) => {
                // Get Shippment_services
                this.$store.state.loaderProps.visible = true;
                response.data.data.forEach( x => { 
                    x = x.attributes;   
                    x['actions'] = JSON.parse(JSON.stringify(this.actions));
                    x['actions'][1].link = "/shipments/prepaid/incidence/" + x.id;
                    x.parameters = x;
                    this.props.items.push(x);
                })
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            })
        },
        showDetails(order){
            this.orderToShow = order;
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.get(this.$store.state.chronosApi + 'shipment/getOrderInformation/' + order.id, {headers: {Authorization: lsToken}})
            .then((response) => {
                response.data = response.data.data.attributes;
                this.$store.state.loaderProps.visible = false;
                this.orderToShow = response.data;
                this.modalDetail = true;
                // response.data.statuses.forEach( x => {
                //     this.orderToShow['statuses'].push({
                //         status: x.status,
                //         date: (x.date != null && x.time != null) ? new Date(x.date) : x.created_at
                //     })
                // })
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            })
        },
        askRestore(order){
            this.modalDelete = true;
            this.orderToDelete = order;
        },
        restoreOrder(){
            console.log(this.orderToDelete);
        },
        askUpload(){
            this.modalUploadIncidences = true;
        },
        uploadReturns(){
            if(this.$refs.form2.validate()){
                this.createInput2(this.inputFile2);
            }
        },
        exportIdentifier(){
            this.createInput(this.orders_identifier.file, "identifier");
        },
        productsByOrdersSummary(){
            this.createInput(this.products_by_orders_summary.file, "summary");
        },
        createInput(file, type) {
            const promise = new Promise((resolve) => {
                const reader = new FileReader();
                // const vm = this;
                reader.onload = () => {
                    resolve((this.readFile = reader.result));
                };
                reader.readAsText(file);
            });

            promise.then(
                result => {
                    /* handle a successful result */
                    this.readRows = result.split('\r\n');
                    this.readRows.shift();

                    if(type == "identifier") this.downloadIdentifier();
                    else if(type == "summary") this.getProductsByOrder();
                },
                error => {
                    /* handle an error */ 
                    console.log(error);
                }
            );
        },
        downloadIdentifier(){
            this.$store.state.loaderProps.visible = true
            const guides = [];
            if(this.readRows.length > 0){
                this.readRows.forEach((x) => {
                    const num = x.split(',');
                    guides.push(num[0]);
                })
                const lsToken = localStorage.getItem("access_token")
                this.$http.post(this.$store.state.chronosApi + 'orders_identifier', {guides: guides}, { headers: { Authorization: lsToken }, responseType:'blob' })
                .then(response => {
                    this.$store.state.loaderProps.visible = false; 
                    FileSaver.saveAs(response.data,'Guías_Identificadas.xlsx');
                    this.modalOrdersIdentifier = false;
                })
                .catch((err) => {
                    console.log(err)
                    this.$store.state.loaderProps.visible = false;
                    this.modalOrdersIdentifier = false;

                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: this.$t('yego_reports.export_error')
                    };
                })
            }
            else{
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('yego_reports.error_address')
                };
            }  
        },
        getProductsByOrder(){
            this.ordersLength = 0;
            this.$store.state.loaderProps.visible = true
            const guides = [];
            if(this.readRows.length > 0){
                this.readRows.forEach((x) => {
                    const num = x.split(',');
                    guides.push(num[0]);
                })
                const lsToken = localStorage.getItem("access_token")
                this.$http.post(this.$store.state.chronosApi + 'products_by_orders_summary', {guides: guides}, { headers: { Authorization: lsToken }})
                .then(response => {
                    this.$store.state.loaderProps.visible = false; 
                    this.stepper = 3;
                    this.productsSummary = response.data.data;
                    this.ordersLength = response.data.orders;
                    this.products_by_orders_summary.file = [];
                })
                .catch((err) => {
                    console.log(err)
                    this.$store.state.loaderProps.visible = false;
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: this.$t('yego_reports.export_error')
                    };
                })
            }
            else{
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('yego_reports.error_address')
                };
            }
        },
        createInput2(file) {
            const promise = new Promise((resolve) => {
                const reader = new FileReader();
                // const vm = this;
                reader.onload = () => {
                    resolve((this.readFile = reader.result));
                };
                reader.readAsText(file);
            });

            promise.then(
                result => {
                    this.readRows2 = result.split('\r\n');
                    this.sTHeaders2 = this.readRows2[0].toLowerCase().replace(' ', '').split(',');
                    this.readRows2.shift();
                    this.stepper2 = 2;
                },
                error => {
                    /* handle an error */ 
                    console.log(error);
                }
            );
        },
        saveFile(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            var formData = new FormData();
            formData.append("file", this.inputFile2);
            this.$http.post(this.$store.state.chronosApi + 'shipment/returnOrders/file', formData, { headers: { 'Content-Type': 'multipart/form-data', Authorization: lsToken} } )
            .then( response => {
                this.$store.state.loaderProps.visible = false;
                this.responses = response.data
                this.stepper2 = 3;
            })
            .catch(error => {
                console.log(error)
                this.$store.state.loaderProps.visible = false;
            })
        },
        // uploadReturn(){
        //     const lsToken = localStorage.getItem("access_token");
        //     this.returned.client_id = this.$store.state.clientId;
        //     this.$http.post(this.$store.state.chronosApi + 'shipment/returnOrders', {returns: [this.returned]}, {headers: {Authorization: lsToken}} )
        //     .then( response => {
        //         console.log(response)
        //         this.$store.state.loaderProps.visible = false;
        //         this.modalUploadreturn = false;
        //         this.index();
        //     })
        //     .catch(error => {
        //         console.log(error)
        //         this.$store.state.loaderProps.visible = false;
        //     })
        // }
    },
    watch:{
        '$route.params.shipping_service': function() {
            location.reload();
        }
    }
}
</script>

<style lang="scss">
    
</style>